import {AnyAction, Dispatch} from 'redux';
import {connect} from 'react-redux';
import * as PipefyActions from '../actions/PipefyDataActions';
import * as ModalActions from '../../../../common/actions/ModalActions';
import PipefyUpdateView from '../components/views/PipefyUpdateView';
import {State} from '../../../types/mx/reducers';
import { PipefyUpdateStateProps, PipefyUpdateDispatchProps } from '../types/containers';

const mapStateToProps = (state: State): PipefyUpdateStateProps => {
    const pipefyError: string = state.commonLoanApplication.pipefy.errorMessage || null;
    return {
        pipefyError
    };
};

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): PipefyUpdateDispatchProps => {
    return {
        onCancel: () => dispatch(ModalActions.CLOSE_MODAL_ACTION.action()),
        onUpdate: () => dispatch(PipefyActions.UPDATE_PIPEFY_DATA_STATE_REQUEST_ACTION.action())
    };
};

const PipefyUpdateContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(PipefyUpdateView);

export default PipefyUpdateContainer;